import { defineDataset } from './metadata';

export const economicDiffusionDatasets = [
    defineDataset({
        datasetId: 'anthropic_occupation_usage',
        moduleId: 'economic_diffusion',
        title: 'Occupations with highest observed AI exposure',
        titleZh: '观察到的 AI 暴露度最高职业',
        sourceName: 'Anthropic — Labor market impacts of AI',
        sourceUrl: 'https://www.anthropic.com/research/labor-market-impacts',
        dataUrl: 'https://huggingface.co/datasets/Anthropic/EconomicIndex',
        license: 'CC-BY',
        asOf: '2026-03-05',
        retrievedAt: '2026-07-16',
        coverageStart: '2026-03-05',
        coverageEnd: '2026-03-05',
        grain: 'occupation snapshot',
        unit: 'share of task time observed exposed',
        methodologyNote: 'Observed exposure combines theoretical LLM feasibility with sufficient work-related Claude usage, weighting automated use more than augmentative use and task time within an occupation.',
        coverageNote: 'This measures Claude-observed exposure, not economy-wide adoption or jobs displaced. The dashboard retains the ten highest occupations from the published file.',
        confidence: 'medium',
        status: 'partial',
        series: [
            { date: '2026-03-05', value: 74.51, occupation: 'Computer Programmers', soc: '15-1251' },
            { date: '2026-03-05', value: 70.11, occupation: 'Customer Service Representatives', soc: '43-4051' },
            { date: '2026-03-05', value: 67.07, occupation: 'Data Entry Keyers', soc: '43-9021' },
            { date: '2026-03-05', value: 66.74, occupation: 'Medical Records Specialists', soc: '29-2072' },
            { date: '2026-03-05', value: 64.83, occupation: 'Market Research Analysts', soc: '13-1161' },
            { date: '2026-03-05', value: 63.65, occupation: 'Medical Transcriptionists', soc: '31-9094' },
            { date: '2026-03-05', value: 62.79, occupation: 'Wholesale Sales Representatives', soc: '41-4012' },
            { date: '2026-03-05', value: 57.87, occupation: 'Database Architects', soc: '15-1243' },
            { date: '2026-03-05', value: 57.16, occupation: 'Financial and Investment Analysts', soc: '13-2051' },
            { date: '2026-03-05', value: 51.95, occupation: 'Software QA Analysts and Testers', soc: '15-1253' },
        ],
    }),
    defineDataset({
        datasetId: 'anthropic_collaboration',
        moduleId: 'economic_diffusion',
        title: 'How people collaborate with Claude',
        titleZh: '人与 Claude 的协作方式',
        sourceName: 'Anthropic Economic Index',
        sourceUrl: 'https://www.anthropic.com/research/economic-index',
        dataUrl: 'https://huggingface.co/datasets/Anthropic/EconomicIndex',
        license: 'CC-BY',
        asOf: '2025-03-27',
        retrievedAt: '2026-07-16',
        coverageStart: '2025-03-27',
        coverageEnd: '2025-03-27',
        grain: 'interaction-mode share',
        unit: 'percent of classified interactions',
        methodologyNote: 'Use the V2 interaction-mode distribution published with the March 2025 Economic Index release. Modes remain disaggregated rather than forcing a new automation/augmentation aggregate.',
        coverageNote: 'A Claude-specific historical snapshot. Later Economic Index releases changed sampling surfaces and classifiers, so V1 does not splice them into a false continuous series.',
        confidence: 'medium',
        status: 'partial',
        series: [
            { date: '2025-03-27', value: 29.42, mode: 'directive' },
            { date: '2025-03-27', value: 12.25, mode: 'feedback_loop' },
            { date: '2025-03-27', value: 27.08, mode: 'learning' },
            { date: '2025-03-27', value: 3.24, mode: 'none' },
            { date: '2025-03-27', value: 24.04, mode: 'task_iteration' },
            { date: '2025-03-27', value: 3.97, mode: 'validation' },
        ],
    }),
    defineDataset({
        datasetId: 'anthropic_artifact_mix',
        moduleId: 'economic_diffusion',
        title: 'Most common Claude conversation outputs',
        titleZh: 'Claude 对话最常见产出',
        sourceName: 'Anthropic Economic Index — Cadences',
        sourceUrl: 'https://www.anthropic.com/research/economic-index-june-2026-report',
        license: 'Anthropic publication terms',
        asOf: '2026-06-10',
        retrievedAt: '2026-07-16',
        coverageStart: '2026-04-10',
        coverageEnd: '2026-06-10',
        grain: 'artifact category share of chat and Cowork conversations',
        unit: 'percent of conversations',
        methodologyNote: 'Record the three most common artifacts stated in the report text. Anthropic classified more than 30 output types across sampled chat and Cowork conversations.',
        coverageNote: 'The report says 93% of conversations produced an artifact. These top-three shares are not an exhaustive distribution and exclude Claude Code and first-party API traffic.',
        confidence: 'high',
        status: 'partial',
        series: [
            { date: '2026-06-10', value: 17, artifact: 'explanations' },
            { date: '2026-06-10', value: 15, artifact: 'documents_and_reports' },
            { date: '2026-06-10', value: 11, artifact: 'guidance' },
        ],
    }),
];
